import React from 'react'
import PropTypes from 'prop-types'
import { connect } from 'react-redux'
import { Modal } from 'components/UIElements'
import NavBar from '../NavBar'
import ErrorBox from '../ErrorBox'
import './CoreLayout.scss'

const CoreLayout = props => {
  const { modal, children } = props
  return (
    <div className='layout-container'>
      <Modal {...modal} />
      <NavBar />
      <div className='core-layout__viewport'>
        <ErrorBox />
        {children}
      </div>
    </div>
  )
}

const mapStateToProps = state => ({ modal: state.modal, drawer: state.drawer })

export default connect(
  mapStateToProps,
  null
)(CoreLayout)

CoreLayout.propTypes = {
  children: PropTypes.element.isRequired,
  modal: PropTypes.object,
  drawer: PropTypes.object,
  location: PropTypes.object
}



// WEBPACK FOOTER //
// ./src/layouts/CoreLayout/CoreLayout.js